import React from "react"

export const Button = ({
  children,
  onClick,
  type = "button",
  disabled = false,
  variant = "default", // 'default', 'active', 'ghost'
  className = "",
  ...props
}) => {
  const getButtonClass = () => {
    const baseClass = "submit-button"
    if (variant === "active") {
      return `${baseClass} active`
    }
    return baseClass
  }

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${getButtonClass()} ${className}`}
      {...props}
    >
      <span className="button-text">{children}</span>
    </button>
  )
}
